import * as Lambda from './LambdaApi';

interface OrderInterface {
  contact: string;
  isExistingUser: boolean | null;
}


const getOrderById = async (id): Promise<OrderInterface> => {
  try {
    const apiPath = `/orders/woocomm/${id}`;
    const order = await Lambda.Get(apiPath, {}, 'public');


    console.log(order,'or');

    return order;
  } catch (err) {
    console.log('error:',err);

    return {
      contact: '', 
      isExistingUser: null, 
    };

    throw Error(err);
  }
}

const associateReceiptWithUser = async (orderId) => {
    const apiPath = `/orders/${orderId}/user`;
    try {
        const request = await Lambda.Post(apiPath, {}, 'lambda');
        return request;
    } catch (err) {
        console.error(err);
        return false;
    }
};

export { getOrderById, associateReceiptWithUser };